
import * as React from "react"
import ReactDOM from 'react-dom'
import { Line } from 'react-chartjs-2';
import {addMinutes, LOG} from "../tools";
import 'chartjs-adapter-date-fns';
import {
    SColorPrimary,
    SColorSecondary,
    SColorText,

} from "../../gatsby-plugin-theme-ui-old"; // date-fns lower than moment ?
import {useEffect, useRef, useState} from "react";
import {Box} from "@chakra-ui/react";
import theme, {SFontBody} from "../../@chakra-ui/gatsby-plugin/theme";

export const GraphTimeLineMain = ({dataMainGraph,stepWindow,stepWindowWord})=>{

    const optionsDate = (stepWindow>=60*24)?{ year: 'numeric', month: 'long', day: 'numeric' }:{ year: 'numeric', month: 'long', day: 'numeric', hour:'2-digit',minute:'2-digit' };

    const list_value = dataMainGraph.d
    //The pattern yyyy-MM-dd isn't an officially supported format for Date
    const startDate = new Date(dataMainGraph.sd.replace(/-/g, "/"))

    const listKeyWords = dataMainGraph.kwbh

    const [datasetMainGraph,setDatasetMainGraph] = useState([])
    const [datasetKeyWords,setDatasetKeyWords] = useState([])
    const [labelKeyWords,setLabelKeyWords] = useState([])
    const [listLabel,setListLabel] = useState([])
    const [endDateGraph,setEndDateGraph] = useState(null)


    useEffect(()=>{
        if(list_value.length>0){
            let list_label = []
        list_value.forEach((value,i)=>{

            list_label.push(addMinutes(startDate,i*stepWindow)
                 )
        })
        setListLabel(list_label)

        let endDate = startDate
        let maxValue = 0
        let datasetMainGraphTmp = []
        list_value.forEach((value,i)=> {

            /*if(i == 0){
                const datetmp_start = addMinutes(startDate,-1*stepWindowWord )
                datasetMainGraphTmp.push({x:datetmp_start, y:value, title:`${datetmp_start.toLocaleDateString("fr-FR", optionsDate)}`})
            }*/
            const dateTmp = addMinutes(startDate,i*stepWindow )
            datasetMainGraphTmp.push({x:dateTmp, y:value, title:`${dateTmp.toLocaleDateString("fr-FR", optionsDate)}`})
            if(i == (list_value.length -1)){
                const datetmp_end = addMinutes(startDate,i*stepWindow + stepWindowWord)
                datasetMainGraphTmp.push({x:datetmp_end, y:value, title:`${datetmp_end.toLocaleDateString("fr-FR", optionsDate)}`})
            }
            if(value>maxValue){
                maxValue = value
            }
            endDate = dateTmp
        })
        const heightValueLabel = Math.floor(maxValue / 20)
        let hourAdd = 0
        let labelKeyWordsTmp = []
        let datasetKeyWordsTmp = []
        listKeyWords.forEach((jsonKeyWords,numKeyWord) =>{

        const title = `${addMinutes(startDate,hourAdd*stepWindowWord).toLocaleDateString("fr-FR", optionsDate)} - ${addMinutes(startDate,(hourAdd + jsonKeyWords["da"])*stepWindowWord).toLocaleDateString("fr-FR", optionsDate)}`
        hourAdd+=jsonKeyWords["da"]/2
        const minFromStart = hourAdd * stepWindowWord - 50
        const stepInListValue = Math.round(hourAdd *( stepWindowWord/stepWindow)) // one value every stepWindow min
        let shiftY = 0

        if(numKeyWord>0){
            const lastKW = datasetKeyWordsTmp[numKeyWord-1]
            const yLastKW = list_value[lastKW["i"]] + lastKW["sy"] * heightValueLabel
            const yKW = list_value[stepInListValue]
            const diffHeight = Math.abs(yKW - yLastKW)
            if( diffHeight<heightValueLabel){
                //need to add little shift
                if(lastKW["sy"]<0 ){
                    shiftY= lastKW["sy"]  + 1
                }else{
                    shiftY= lastKW["sy"]  - 1
                }

            }
        }
        datasetKeyWordsTmp.push({x:addMinutes(startDate,minFromStart), i:stepInListValue,
            y:maxValue,
            title:title,
            sy:shiftY,
            label: jsonKeyWords["kws"].join(" "),
            l:jsonKeyWords["kws"][0]})
        hourAdd += jsonKeyWords["da"]/2
        labelKeyWordsTmp.push(`${jsonKeyWords["kws"][0]}`)
        })
        setEndDateGraph(addMinutes(endDate,stepWindowWord))
        setDatasetMainGraph(datasetMainGraphTmp)
        setDatasetKeyWords(datasetKeyWordsTmp)
        setLabelKeyWords(labelKeyWordsTmp)
        }


    }, [dataMainGraph])


const heightGraph = 450
const colorG = theme.colors.primary
const colorGSecond = theme.colors.bg
const setGradientColor = (canvas, color) => {
    if (!color) return;
    const ctx = canvas.getContext("2d");
    //const gradient = ctx.createLinearGradient(0, 100, 900, 195);
    const gradient = ctx.createLinearGradient(0, 0, 0, heightGraph);
    gradient.addColorStop(0, color[500]);
    //gradient.addColorStop(0.5, color[300]);
    gradient.addColorStop(1, 'rgba(244, 238, 235,0.5)');
    return gradient;
  };

const data = (canvas) => {
    return {
        labels: listLabel,
            datasets: [{
             type:'line',
        data: datasetMainGraph,
        label: "Nb Tweet",
        lineTension:0.6,
                order:0,
        borderWidth:1,
        pointRadius:0,
        backgroundColor:setGradientColor(canvas,colorG),
        borderColor: colorG[500],
          fill:true,
       //   hoverBackgroundColor:colorG[500],
       //   hoverBorderColor:colorG[500],
    },
            {
                    type: 'bar',
        data: datasetKeyWords,
                    skipNull:true,
                order:1,
        label: labelKeyWords,
        borderWidth:0,
                minBarLength:0,
                barPercentage:1,
                categoryPercentage:1,
                barThickness:'flex',
        borderRadius: 0,
        yAxisID: 'y',
        xAxisID: 'x',
        backgroundColor:`${colorGSecond[900]}02`,
                hoverBackgroundColor:`${colorGSecond[900]}ff`,
       // borderColor: `${SColorText[50]}50`,
          fill:true,
    }
            ]
    }
}

    const options = {
    responsive: true,
    maintainAspectRatio:false,
     /*   animation: {
        duration: 1000
    },*/
    plugins:{
         tooltip: {
             enabled:true,
            mode: 'nearest',
             displayColors:false,
                intersect:true,
            callbacks: {
                title: function(tooltipItem, data) {

                    if(tooltipItem[0].dataset.type=="bar"){
                        return  `${tooltipItem[0].raw.title}`
                    }else{
                        return tooltipItem[0].raw.title
                    }
                },
                labelTextColor: function(){
                    return SColorSecondary[700]
                },
                label: function(tooltipItem, data) {
                    if(tooltipItem.dataset.type=="bar"){
                        return  `${tooltipItem.raw.label  }`
                    }else{

                        return  `${tooltipItem.raw.y  } tweets dans les 5 minutes`
                    }

                },
            },
        },
       legend: {
               //     onClick: (e, item) => LOG(`Item with text ${item.text} and index ${item.index} clicked`),
           // onHover: (e, item) => LOG(`Item with text ${item.text} and index ${item.index} hovered`),
                    display:false,
                }
    },

  scales: {
      x:{grid: {
                display:false,
                    drawBorder: false,
            },type: 'timeseries',
        distribution: 'linear',
          //bounds:'data',
          min:startDate,
          max:endDateGraph,
          time: {
          unit:(stepWindow>=60*24)?'day':'hour',
              stepSize:(stepWindow>=60*24)?7:12,
          displayFormats: {
              day:'dd MMM',
                         minute: 'h:MM',
                hour: "dd/MM-HH:mm"
                    },
            ticks:{
                  source:'auto',
            }
            }
            },
    y: {
      display: true,

        ticks: {  beginAtZero: false, display: false     },
        grid: {  display:false,   drawBorder: false,  },
      title: {    display: false}
    },
      y1: {
      display: true,
        ticks: {  beginAtZero: false, display: false     },
        grid: {  display:false,   drawBorder: false,  },
      title: {    display: false}
    }
  },
        layout:{
        padding:{
      left: 10,
      right: 30,
      top: 50,
      bottom: 0,
    }
        }
};
const drawText =(chart)=> {
                  // const ctx = chart.canvas.getContext('2d');
     if (ref.current != null){
                   const ctx = ref.current.canvas.getContext('2d') //.ctx;
            //ctx.restore();
                let width = chart.width
              let height = chart.height
              //ctx.restore();
              let fontSize = Math.max((width / 850).toFixed(2),0.85);
              ctx.font = `${fontSize}em ${SFontBody}`;
              ctx.textBaseline = "top";
         const datasetLine = ref.current._metasets[0]
         const datasetBar = ref.current._metasets[1]
         datasetBar.data.forEach(function (bar, index) {
                          //LOG("bar",bar)
                          // ctx.measureText(text).width // to know the with of text.
             if(datasetLine.data.length != 0) {

                 const text = bar.$context.raw.l
                 //LOG(text,'->',datasetLine.data[bar.$context.raw.i].y,bar.$context.raw.sy,bar.y,height)
                 /// get width of text
                 const measure = ctx.measureText(text)
                 const widthText = measure.width;

                const valLine = datasetLine.data[bar.$context.raw.i]
                 let valLineY = valLine?valLine.y:0
                 if (bar.$context.raw.sy!=0){
                     valLineY += bar.$context.raw.sy * (bar.$context.raw.y/30)
                 }

             const yText = valLineY - 30
                /// draw background rect assuming height of font
                ctx.fillStyle = `${SColorText[50]}f0`;
                ctx.fillRect( bar.x, yText, widthText, parseInt(ctx.font, 10));
                ctx.fillStyle = SColorText[300];
                ctx.fillText(text, bar.x, yText);
             }
              });

                 /*   ref.current._metasets.forEach(function (dataset) {
                  if (dataset.type === 'bar') {
                      dataset.data.forEach(function (bar, index) {
                          //LOG("bar",bar)
                          // ctx.measureText(text).width // to know the with of text.
                         ctx.fillText(bar.$context.raw.l, bar.x, bar.y + 30);
                      });
                  }
                  ;
              })*/
                    //ctx.save();
                setIsTextShown(true)

            }
}

    const ref = useRef();
    const [isTextShown,setIsTextShown] = useState(false)

    return <Box sx={{mt:'-15px',pl:0,pr:1, height:400,width:'100%'}}>
        <Line ref={ref} data={data} options={options} plugins={[{
            afterDatasetDraw: (chart)=> {
                drawText(chart)
             }

        }]}
        />
    </Box>
}
